module.exports = "https://static.wanderu.com/static/media/flat-iphone.f3bddd0f.png";